import React from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
import ShippingPreferencesPanel from './shipping-preference-panel';
import { IAccountShippingPreferences } from '../../../../models/shipping-preferences';
import { AccountType } from '../../../../models/account';

interface ShippingPreferencesTabPaneProps {
    accountShippingPreferences: IAccountShippingPreferences | null;
    accountType: AccountType;
    isReadOnly: boolean;
    handleChange: (e: React.ChangeEvent<any>, index?: number) => void;
}

const ShippingPreferencesTabPane: React.FC<ShippingPreferencesTabPaneProps> = ({
    accountShippingPreferences = null,
    accountType,
    isReadOnly,
    handleChange,
}) => {
    const intl = useIntl();
    const accountTypePrefix =
        accountType === AccountType.BillTo ? 'billTo' : 'shipTo';

    return (
        <>
            {accountShippingPreferences && (
                <>
                    <ShippingPreferencesPanel
                        heading={intl.formatMessage({
                            id: 'Hearing_Aids_Wireless_Accessories_Chargers',
                        })}
                        body={intl.formatMessage({
                            id: 'Includes_Receiver_In_Canal_With_Power',
                        })}
                        shippingMethods={[
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery',
                                }),
                                value: 'Overnight, next day delivery',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Second_Day_Air',
                                }),
                                value: 'Second Day Air',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery_By_1030',
                                }),
                                value: 'Overnight, next day by 10:30',
                            },
                        ]}
                        shippingPreference={
                            accountShippingPreferences.defaultShippingMethods[2]
                        }
                        accountType={accountType}
                        namePrefix={`${accountTypePrefix}.defaultShippingMethods[2]`}
                        isReadOnly={isReadOnly}
                        handleChange={(e) => handleChange(e, 2)}
                    />
                    <ShippingPreferencesPanel
                        heading={intl.formatMessage({
                            id: 'earmold_orders_repairs_remakes',
                        })}
                        shippingMethods={[
                            {
                                text: intl.formatMessage({
                                    id: 'First_Class_Mail_Tracking_1-3days',
                                }),
                                value: 'First Class Mail With Tracking 1-3 Days',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Ground_1-5_days_intransit_dep_on_zone',
                                }),
                                value: 'Ground, 1-5 days intransit depending on zone',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery',
                                }),
                                value: 'Overnight, next day delivery',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Second_Day_Air',
                                }),
                                value: 'Second Day Air',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery_By_1030',
                                }),
                                value: 'Overnight, next day by 10:30',
                            },
                        ]}
                        shippingPreference={
                            accountShippingPreferences.defaultShippingMethods[1]
                        }
                        accountType={accountType}
                        namePrefix={`${accountTypePrefix}.defaultShippingMethods[1]`}
                        isReadOnly={isReadOnly}
                        handleChange={(e) => handleChange(e, 1)}
                    />
                    <ShippingPreferencesPanel
                        heading={intl.formatMessage({
                            id: 'Battery_Orders',
                        })}
                        shippingMethods={[
                            {
                                text: intl.formatMessage({
                                    id: 'First_Class_Mail_Tracking_1-3days',
                                }),
                                value: 'First Class Mail With Tracking 1-3 Days',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Ground_1-5_days_intransit_dep_on_zone',
                                }),
                                value: 'Ground, 1-5 days intransit depending on zone',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery',
                                }),
                                value: 'Overnight, next day delivery',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Second_Day_Air',
                                }),
                                value: 'Second Day Air',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery_By_1030',
                                }),
                                value: 'Overnight, next day by 10:30',
                            },
                        ]}
                        shippingPreference={
                            accountShippingPreferences.defaultShippingMethods[0]
                        }
                        accountType={accountType}
                        namePrefix={`${accountTypePrefix}.defaultShippingMethods[0]`}
                        isReadOnly={isReadOnly}
                        handleChange={(e) => handleChange(e, 0)}
                    />
                    <ShippingPreferencesPanel
                        heading={intl.formatMessage({
                            id: 'Common_Supplies',
                        })}
                        body={intl.formatMessage({
                            id: 'Common_Supplies_Notes',
                        })}
                        shippingMethods={[
                            {
                                text: intl.formatMessage({
                                    id: 'First_Class_Mail_Tracking_1-3days',
                                }),
                                value: 'First Class Mail With Tracking 1-3 Days',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Ground_1-5_days_intransit_dep_on_zone',
                                }),
                                value: 'Ground, 1-5 days intransit depending on zone',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery',
                                }),
                                value: 'Overnight, next day delivery',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Second_Day_Air',
                                }),
                                value: 'Second Day Air',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery_By_1030',
                                }),
                                value: 'Overnight, next day by 10:30',
                            },
                        ]}
                        shippingPreference={
                            accountShippingPreferences.defaultShippingMethods[4]
                        }
                        accountType={accountType}
                        namePrefix={`${accountTypePrefix}.defaultShippingMethods[4]`}
                        isReadOnly={isReadOnly}
                        handleChange={(e) => handleChange(e, 4)}
                    />
                    <ShippingPreferencesPanel
                        heading={intl.formatMessage({
                            id: 'Repairs_Remakes_Loss_Damage',
                        })}
                        body={intl.formatMessage({
                            id: 'Repairs_Remakes_Loss_Damage_Notes',
                        })}
                        shippingMethods={[
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery',
                                }),
                                value: 'Overnight, next day delivery',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Second_Day_Air',
                                }),
                                value: 'Second Day Air',
                            },
                            {
                                text: intl.formatMessage({
                                    id: 'Overnight_Next_Day_Delivery_By_1030',
                                }),
                                value: 'Overnight, next day by 10:30',
                            },
                        ]}
                        shippingPreference={
                            accountShippingPreferences.defaultShippingMethods[3]
                        }
                        accountType={accountType}
                        namePrefix={`${accountTypePrefix}.defaultShippingMethods[3]`}
                        isReadOnly={isReadOnly}
                        handleChange={(e) => handleChange(e, 3)}
                    />
                </>
            )}
        </>
    );
};

export default ShippingPreferencesTabPane;
